import { render, staticRenderFns } from "./TrailerOrder.vue?vue&type=template&id=cf3637ec&scoped=true&"
import script from "./TrailerOrder.vue?vue&type=script&lang=js&"
export * from "./TrailerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3637ec",
  null
  
)

export default component.exports